/**
 * VAT (BE-9) — real API.
 *
 * Periods run from the ledger start to the current one, newest first; open periods are calculated (`id` null) and are
 * identified by their start date. Filing locks a period; payments to the FTA come from a TC operations bank account or
 * a TC credit card (several allowed); a refund goes to a bank account. A non-registered TC gets the server's 400.
 */

import ApiService from '../api.service';
import { keysCamelToSnake, unwrapData, unwrapList } from '../../utils/apiConvert';

const clean = (obj) => Object.fromEntries(Object.entries(obj || {}).filter(([, v]) => v !== '' && v !== undefined && v !== null));
const body = (data) => keysCamelToSnake(clean(data));

export const vatReturnService = {
  getTaxPeriods: async () => unwrapList(await ApiService.get('/api/tax-periods')).items,

  // The return for the period starting on startDate (a filed period returns its snapshot).
  getVatReturn: async (startDate) => unwrapData(await ApiService.get('/api/reports/vat-return', { params: { startDate } })),

  filePeriod: async (startDate) => unwrapData(await ApiService.post('/api/tax-periods/file', null, { params: { startDate } })),

  // data: { amount, paymentDate, bankAccountId | cardId, reference }
  recordPayment: async (periodId, data) =>
    unwrapData(await ApiService.post(`/api/tax-periods/${periodId}/record-payment`, body(data))),

  // data: { amount, paymentDate, bankAccountId, reference }
  recordRefund: async (periodId, data) =>
    unwrapData(await ApiService.post(`/api/tax-periods/${periodId}/record-refund`, body(data))),

  // data: { taxPeriodId, journalEntryIds, reference }
  /** BE-31: the latest filed period back to open (TC admin, a reason; refused once paid or refunded). */
  unfilePeriod: async (periodId, reason) =>
    unwrapData(await ApiService.post(`/api/tax-periods/${periodId}/unfile`, { reason })),
  /** BE-31: the TC admin's lock date - `{ lockDate, cutoverDate }`. */
  getLockDate: async () => unwrapData(await ApiService.get('/api/periods/lock-date')),
  updateLockDate: async (lockDate, reason) =>
    unwrapData(await ApiService.put('/api/periods/lock-date', { lock_date: lockDate || null, reason: reason || null })),
  recordDisclosure: async (data) => unwrapData(await ApiService.post('/api/tax-periods/disclosures', keysCamelToSnake(data))),

  getVatSettings: async () => unwrapData(await ApiService.get('/api/settings/vat')),

  // data: { vatRegistered, trn, vatRate, periodMonths, firstPeriodMonth }
  updateVatSettings: async (data) => unwrapData(await ApiService.put('/api/settings/vat', keysCamelToSnake(data))),
};

export default vatReturnService;
